import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { PriceBlock } from '../PriceBlock';
import { HERO_MOCKUP, OFFER_ITEMS, PRODUCT } from '../../data/catio';

/**
 * First price reveal. The hero CTA scrolls here (#offer).
 * This CTA — unlike the hero one — opens the real checkout.
 * `#offer-price` and `#offer-cta` drive the mobile sticky bar.
 */
export function OfferSection() {
  return <section aria-labelledby="offer-title" className="bg-ink py-12 sm:py-20" data-id="element-211" data-mp="1q81ylhi0aoy">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-8" data-id="element-212" data-mp="3swj9n0h0k9p9">
        <SectionHeading id="offer-title" tone="dark" align="center" eyebrow="The complete collection" title="Get the Complete CATIO READY™ Collection" data-id="element-213" data-mp="3sx2epglkf3lv" />

        <div className="mt-8 overflow-hidden rounded-[22px] bg-paper shadow-[0_40px_80px_-40px_rgba(0,0,0,0.8)] sm:mt-10 lg:grid lg:grid-cols-[1fr_1fr]" data-id="element-214" data-mp="3j0pquzcpbjz1">
          <div className="flex items-center justify-center border-b border-line bg-stone px-4 pb-4 pt-6 lg:border-b-0 lg:border-r lg:px-8 lg:py-10" data-id="element-215" data-mp="1aqz9lro5kkf2">
            <img src={HERO_MOCKUP.src} alt={HERO_MOCKUP.alt} width={HERO_MOCKUP.width} height={HERO_MOCKUP.height} loading="lazy" decoding="async" className="h-[230px] w-auto max-w-full object-contain drop-shadow-[0_18px_26px_rgba(28,31,28,0.18)] sm:h-[300px] lg:h-auto lg:max-h-[480px]" data-id="element-216" data-mp="1fkk2546z8m6v" />
          </div>

          <div className="px-5 pb-7 pt-6 sm:px-10 sm:pb-10 sm:pt-9" data-id="element-217" data-mp="1ki3oyshqq7af">
            <p className="wordmark text-[1.7rem] text-ink" data-id="element-218" data-mp="1kjwn1jeafj6t">
              Catio <span className="text-ember" data-id="element-219" data-mp="1oi43ed4uaihh">Ready</span>™
            </p>
            <p className="mt-1.5 text-[0.92rem] text-graphite" data-id="element-220" data-mp="925c0djfz13x">{PRODUCT.descriptor}</p>

            <ul className="mt-5 grid gap-2.5" data-id="element-221" data-mp="d40bdchtb4f2">
              {OFFER_ITEMS.map(item => {
              const free = item.includes('FREE');
              return <li key={item} className="flex items-center gap-3 text-[1rem] font-semibold text-ink" data-id="element-222" data-mp="2ft05rk7wmobd">
                    <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${free ? 'border border-ember text-ember' : 'bg-ink text-cream'}`} aria-hidden data-id="element-223" data-mp="25zt52co3zwhm">
                      <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-224" data-mp="1s0b8vc8hhgy8" />
                    </span>
                    {free ? <span data-id="element-225" data-mp="1n2i5ss2h9326">
                        {item.replace(' FREE', '')} <span className="text-ember" data-id="element-226" data-mp="1i3yk8srsptac">FREE</span>
                      </span> : item}
                  </li>;
            })}
            </ul>

            {/*
              #offer anchor sits on the purchase block itself (price + buy button), so the
              hero CTA lands with both on screen. The scroll margin (added to the page's
              sticky-header padding) roughly centers this block in the viewport.
             */}
            <div id="offer" style={{
            scrollMarginTop: 'max(1rem, calc(50svh - 11rem))'
          }} data-id="element-227" data-mp="3tr20xz0p6dzi">
              <div className="mt-6 border-t border-line pt-6" data-id="element-228" data-mp="2iwbufp4d4zv">
                <PriceBlock id="offer-price" data-id="element-229" data-mp="31zuhh55goi7a" />
              </div>

              <CTAButton id="offer-cta" label="Get CATIO READY™ Now" size="lg" className="mt-6 w-full" data-id="element-230" data-mp="321p4qq47gmej" />

              <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.84rem] text-graphite" data-id="element-231" data-mp="3ayppmms2g2d8">
                <li className="flex items-center gap-1.5" data-id="element-232" data-mp="q9s9htg9auf1">
                  <LockIcon className="h-3.5 w-3.5 text-wood" aria-hidden data-id="element-233" data-mp="q9a1jzk8erra" /> Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-234" data-mp="v71wl2g6atzp">
                  <ZapIcon className="h-3.5 w-3.5 text-wood" aria-hidden data-id="element-235" data-mp="2451qks1fwo8o" /> Instant digital access
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}